import React from 'react';
import Container, { ContainerSize } from 'components/Container';
import Image from 'components/Image';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  quoteText: string;
  authorName: string;
  authorDescription: string;
  size?: ContainerSize;
  flush?: boolean;
};

type DefaultProps = {
  size: ContainerSize;
  flush: boolean;
};

export default class QuoteBox extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    size: 'medium',
    flush: true,
  };

  render() {
    return (
      <Container size={this.props.size} flush={this.props.flush}>
        <Row size="small">
          <Image src={require('assets/images/quote.svg')} />
        </Row>
        <Row size="small">
          <Text weight="light" size="large">
            {this.props.quoteText}
          </Text>
        </Row>
        <Row size="xxsmall">
          <Text size="xsmall">
            {this.props.authorName}
          </Text>
        </Row>
        <Row>
          <Text size="xxxsmall">
            {this.props.authorDescription}
          </Text>
        </Row>
      </Container>
    );
  }
}
